<template>
    <div class="add-resource">
        <file-uploader v-model="file"/>
    </div>
</template>

<script>
import FileUploader from "@/Components/Common/FileUploader";
export default {
    name: "AddResourceTabContent",
    components: {FileUploader},

    data(){
        return {
            // uploads: null,
            file: null,
        }
    }
}
</script>

<style lang="scss" scoped>
.add-resource{
    padding: 2rem 1rem;
}
</style>
